import $ from "jquery";
import Header from "./components/Header";
import VideoHeader from "./components/VideoHeader";
import Smartreward from "./components/Smartreward";
import Storelocator from "./components/Storelocator";
import Email from "./components/Email";
import Gallery from "./components/Gallery";
import Dropdowntable from "./components/Dropdowntable";
import FormComponent from "./components/Form";
import ConnectRegister from "./components/Connectregister";
// END COMPONENT IMPORTS

$(document).ready(() => {
	Header();
	VideoHeader();
	Smartreward();
	Storelocator();
	Email();
	Gallery();
	Dropdowntable();
	FormComponent();
	ConnectRegister();
	// END COMPONENT CALLS
});
